import React from 'react';
import { SwitchStyled, Typography } from '@commonsku/styles';

type CalculatePodShippingAutomaticallyConfigProps = {
  selected: boolean;
  onToggle: () => void;
};

const CalculatePodShippingAutomaticallyConfig = ({
  selected,
  onToggle,
}: CalculatePodShippingAutomaticallyConfigProps) => (
  <>
    <div className="small-12 medium-12 columns" style={{ width: '100%', marginLeft: 0, marginRight: 0, padding: 0 }}>
      <hr />
    </div>
    <div className="small-12 columns">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Typography.Text fontSize="20px" bold style={{ paddingRight: 24 }}>
          Calculate shipping automatically
        </Typography.Text>
        <SwitchStyled
          size="medium"
          selected={selected}
          onClick={onToggle}
          data-testid="calculate_pod_shipping_automatically_toggle"
        />
      </div>
    </div>
  </>
);

export default CalculatePodShippingAutomaticallyConfig;
